import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Selection } from '../../../selection/models';

@Component({
    selector: 'app-multi-selection-control',
    templateUrl: './multi-selection-control.component.html',
    styleUrls: ['./multi-selection-control.component.scss'],
    standalone: false
})
export class MultiSelectionControlComponent {
    @Input() formGroup: UntypedFormGroup | undefined;
    @Input() selections: Selection[] = [];
    @Input() control: AbstractControl | null | undefined;
    @Input() formControlName: string | undefined;
    @Input() header: string | undefined;
    @Input() label: string | undefined;
    @Input() requiredMessage: string | undefined;
    @Input() formSubmitted: boolean | undefined;

    updateCheckboxGroup(event: MatCheckboxChange) {
        if (!this.formControlName || !this.control || !this.formGroup)
            throw new Error('`formControlName` input must be provided');

        const indexOfSelection = this.control?.value?.indexOf(
            Number(event.source.value)
        );
        if (
            event.source.checked &&
            (indexOfSelection === -1 ||
                indexOfSelection === undefined ||
                indexOfSelection === null)
        ) {
            this.control?.value?.push(Number(event.source.value));
        } else {
            this.control?.value?.splice(indexOfSelection, 1);
        }

        // update the control value since the validator references the object
        // at init
        const control = this.formGroup.get(this.formControlName);
        control?.setValue(this.control.value);
        this.control.markAsTouched();
    }
}
